<template>
  <div class="app-shell">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppShell'
};
</script>

<style>
.app-shell {
  height: 100vh;
  overflow: hidden;
}

.page-card--table {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.page-table-wrap {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.page-table {
  width: 100%;
}

.page-card--table .page-toolbar,
.page-card--table .page-pagination,
.page-card--table .page-actions,
.page-card--table .page-note {
  flex-shrink: 0;
}
</style>
